import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../../config/endpoints';
import { popupSlice } from "../../../services/reducers";
import { setLoading } from '../../../services/reducers/homeSlice';
import restApi from '../../../services/restApi';
import { useAppSelector } from '../../../services/store';
import tools from '../../../utils/tools';
import LoadingBody from '../../App/loading/LoadingBody';

const BillDetail = ({ stores, orderProduct, fetchData = () => {} }) =>{
  const dispatch: any = useDispatch()
  const [isloading, setIsloading] = useState(false);
  const [buyPrice, setBuyPrice] = useState(orderProduct?.buyPrice);
  const [sellPrice, setSellPrice] = useState(orderProduct?.price);
  const [store, setStore] = useState(orderProduct?.storeId);
  const [newStore, setNewStore] = useState<any>({});

  const send = async () => {
    dispatch(setLoading(true));

    let storeId = store;

    if (!store){
      const res = await restApi(endpoints.store.basic).post(tools.extractor(newStore,['title', 'address', 'phoneNumber']))

      if (res.code == 200){
        storeId = res.data.id;
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: 'فروشگاه ساخته نشد',
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
        dispatch(setLoading(false));
        return
      }
    }

    const res = await restApi(endpoints.orderProduct.update + orderProduct.id, true).put({
      sellPrice: sellPrice,
      buyPrice: buyPrice,
      storeId: storeId,
    })

    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: 'قیمت ها با موفقیت دخیره شدند',
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          fetchData()
          dispatch(popupSlice.hide())
        }
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }

    dispatch(setLoading(false));
  };

  if (isloading){
    return (
      <main className="billBody">
        <LoadingBody/>
      </main>
    )
  }

  return(
    <main className="billMain billSec">
    <span className="blueText billHeader">
      جزئیات صورتحساب
    </span>
    <span className="billDetSpan fontSize">
      <p className="textAlignRight">  {Number(orderProduct?.count)} عدد </p>
      <p className="blueText">{tools.formatPrice(orderProduct?.product?.title)}</p>
    </span>
      <div className="billForm">
    <span className="billFormSpan">
      <input className="billInput" value={tools.formatPrice(buyPrice)} onChange={(input) => setBuyPrice(Number(input.target.value.replaceAll(',', '')))} />
      <p className="blueText">قیمت خرید (‌تومان)</p>
    </span>
    <span className="billFormSpan">
      <input className="billInput" value={tools.formatPrice(sellPrice)} onChange={(input) => setSellPrice(Number(input.target.value.replaceAll(',', '')))} />
      <p className="blueText">قیمت فروش (‌تومان)</p>
    </span>
    <span className="billFormSpan">
      <Select options={tools.selectFormatter(stores, 'id', 'title', 'فروشگاه جدید')} value={{ value: store, label: stores.find(e => e.id == store)?.title }} className="width45" id="infoTitle" onChange={(selected: any) => setStore(selected.value)}/>
      <p className="blueText">فروشگاه</p>
    </span>
        {!store &&
        <>
          <span className="blueText billHeader borderTop">
            فروشگاه جدید
          </span>
          <span className="billFormSpan">
          <input className="billInput" value={newStore.title} onChange={(input) => setNewStore(prev => ({...prev, title: input.target.value}))} />
          <p className="blueText">عنوان فروشکاه</p>
          </span>
              <span className="billFormSpan">
            <input className="billInput" value={newStore.phoneNumber} onChange={(input) => setNewStore(prev => ({...prev, phoneNumber: input.target.value}))} />
            <p className="blueText">شماره تلفن</p>
          </span>
            <span className="billFormSpan borderBottom">
            <input className="billInput" value={newStore.address} onChange={(input) => setNewStore(prev => ({...prev, address: input.target.value}))} />
            <p className="blueText">آدرس</p>
          </span>
          </>
      }
    </div>
    <span className="billFinalPrice">
      <p className="blueText">قیمت فروش نهایی</p>
      <p>{tools.formatPrice(Number(orderProduct?.count) * Number(sellPrice))}</p>
    </span>
    <span className="billButtons">
      <button className="billButton dashboardHeader" onClick={send}>ثبت قیمت</button>
      <button className="billButton cancelButton" onClick={() => dispatch(popupSlice.hide())}>انصراف</button>
    </span>
    </main>
  )
}
export default BillDetail